export default __webpack_public_path__ + "static/t1-d231be366badb043cf50f931c3474a99.webp";